import { render, staticRenderFns } from "./TaskPopup.vue?vue&type=template&id=984ab272&scoped=true&"
import script from "./TaskPopup.vue?vue&type=script&lang=js&"
export * from "./TaskPopup.vue?vue&type=script&lang=js&"
import style0 from "./TaskPopup.vue?vue&type=style&index=0&id=984ab272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984ab272",
  null
  
)

export default component.exports